import resizedEvent from 'ui-core/utility/resized-event/js/resized-event';
import 'ui-core/plugins/enquireJs/js/enquire';

// this utility works against the mobile first approach
// @todo rewrite to comply with the mobile first approach
(function () {
    var enquireIt = {
        init: function () {
            // Responsive behavior controllers ( media query listeners )
            UX.controller.enabled = true;
            /*eslint-disable*/
            enquire
                .register('screen and (max-width: ' + UX.grid.screenXsMax + 'px)', {
                    match: function () {
                        $(document).trigger('screen-xs-on'); // screen is xs
                        $(document).trigger('smartResize'); // resize have been made
                    },
                    unmatch: function () {
                        $(document).trigger('screen-xs-off'); // screen is not xs anymore
                        $(document).trigger('smartResize'); // resize have been made
                    },
                })
                .register('screen and (max-width: ' + UX.grid.screenSmMax + 'px)', {
                    match: function () {
                        $(document).trigger('screen-sm-on'); // screen is sm
                        $(document).trigger('smartResize'); // resize have been made
                    },
                    unmatch: function () {
                        $(document).trigger('screen-sm-off'); // screen is not sm anymore
                        $(document).trigger('smartResize'); // resize have been made
                    },
                })
                .register('screen and (max-width: ' + UX.grid.screenMdMax + 'px)', {
                    match: function () {
                        $(document).trigger('screen-md-on'); // screen is md
                        $(document).trigger('smartResize'); // resize have been made
                    },
                    unmatch: function () {
                        $(document).trigger('screen-md-off'); // screen is not md anymore
                        $(document).trigger('smartResize'); // resize have been made
                    },
                })
                .register('screen and (min-width: 0px)', {
                    match: function () {
                        $(document).trigger('screen-lg-on'); // screen is lg
                        $(document).trigger('smartResize'); // resize have been made
                    },
                });

            resizedEvent();
        },
    };
    /*eslint-enable*/
    UX.enquireIt = enquireIt; // add to global namespace
})();
